exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-submission-admin-form[data-v-64a132b4]{border:1px solid #eee;padding:1rem;margin-top:1rem}.form-submission-admin-form .form-check .form-check-sign[data-v-64a132b4]:after{color:#fff}", ""]);

// exports
